module.exports = __webpack_public_path__ + "static/media/controller.47f0ed90.md";